module.exports = __webpack_public_path__ + "img/camera-upload.848d2c64.svg";